import React, { useEffect, useState } from "react";
import "./MarqueeSection.css";
import { useTranslation } from "react-i18next";
import axios from "axios";

const MarqueeSection = () => {
  const { i18n } = useTranslation();
  const [marquee, setMarquee] = useState({ title: "", text: "" });

useEffect(() => {
  axios
    .get(
      `https://admin.cmpranesh-admk.com/api/getMarquee.php?lang=${i18n.language}`
    )
    .then((res) => setMarquee(res.data))
    .catch((err) =>
      console.log("Error fetching marquee:", err)
    );
}, [i18n.language]);


  return (
    <div className="cmpr-marquee-wrapper">
      <div className="cmpr-marquee-container">

        {/* LEFT STATIC TEXT */}
        <div className="cmpr-marquee-left">
          <span className="cmpr-marquee-title">{marquee.title}</span>
        </div>

        {/* RIGHT MOVING TEXT */}
        <marquee className="cmpr-marquee-right" direction="left" scrollamount="5">
          {marquee.text}
        </marquee>

      </div>
    </div>
  );
};

export default MarqueeSection;
